module.exports = __webpack_public_path__ + "static/media/vctAssessmentRulesTemplate.cf2a02cf.xlsx";